module.exports = __webpack_public_path__ + "img/popover.2edb9ec3.svg";